export default "__VITE_ASSET__DxkAXR90__"